import personal from './personal'
import contracts from './contracts'
import changePassword from './change-password'

export default {
  profile: {
    namespaced: true,
    modules: {
      personal,
      contracts,
      changePassword
    }
  }
}
